import { ProgramStoreSettings } from "src/app/infrastructure/models/program-store-settings";
import { HomemadeBookProgram } from "./models/homemade-book-program";
import { HomemadeBookProgramStore } from "./stores/homemade-book-program.store";
import { HomemadeBooksProgramSettings } from "./homemade-books-program.settings";

export const HomemadeBooksProgramStoreSettings : ProgramStoreSettings<HomemadeBookProgram> = {
  storeType: HomemadeBookProgramStore,
  programSettings: HomemadeBooksProgramSettings
}
